import settings from '@/settings'
import { store } from '@geek/yum-freight-framework'

const ECOM_BOOKING_PATH = '/ecomBooking'
const ECOM_BOOKING_ROUTE_NAME = 'ecomBooking'
const ECOM_RATES_PATH = '/ecomRates'
const ECOM_RATES_ROUTE_NAME = 'ecomRates'
const ECOM_ORDER_PATH = '/ecomOrder'
const ECOM_ORDER_ROUTE_NAME = 'ecomOrder'

function hasMatchedRoute(router, location) {
  if (!router?.resolve) return false
  const resolved = router.resolve(location)
  return Array.isArray(resolved?.route?.matched) && resolved.route.matched.length > 0
}

function withAppIdPrefix(vm, path) {
  const appId = vm?.$appId || settings.appId || ''
  return appId ? `/${appId}${path}` : path
}

/** 跳转到 90042 电商订舱页 */
export function getEcomBookingPath(vm) {
  const router = vm?.$router
  if (router && hasMatchedRoute(router, { path: ECOM_BOOKING_PATH })) {
    return ECOM_BOOKING_PATH
  }
  if (router && hasMatchedRoute(router, { name: ECOM_BOOKING_ROUTE_NAME })) {
    return router.resolve({ name: ECOM_BOOKING_ROUTE_NAME }).route.path || ECOM_BOOKING_PATH
  }
  return withAppIdPrefix(vm, ECOM_BOOKING_PATH)
}

/** 返回电商运价列表页 */
export function getEcomRatesPath(vm) {
  const router = vm?.$router
  if (router && hasMatchedRoute(router, { path: ECOM_RATES_PATH })) {
    return ECOM_RATES_PATH
  }
  if (router && hasMatchedRoute(router, { name: ECOM_RATES_ROUTE_NAME })) {
    return router.resolve({ name: ECOM_RATES_ROUTE_NAME }).route.path || ECOM_RATES_PATH
  }
  return withAppIdPrefix(vm, ECOM_RATES_PATH)
}

/** 电商订舱订单列表页 */
export function getEcomOrderPath(vm) {
  const router = vm?.$router
  if (router && hasMatchedRoute(router, { path: ECOM_ORDER_PATH })) {
    return ECOM_ORDER_PATH
  }
  if (router && hasMatchedRoute(router, { name: ECOM_ORDER_ROUTE_NAME })) {
    return router.resolve({ name: ECOM_ORDER_ROUTE_NAME }).route.path || ECOM_ORDER_PATH
  }
  return withAppIdPrefix(vm, ECOM_ORDER_PATH)
}

function isEcomBookingVisitedView(view) {
  if (!view) return false
  if (view.name === ECOM_BOOKING_ROUTE_NAME || view.name === 'EcomBooking') return true
  const path = typeof view.path === 'string' ? view.path : ''
  return path.includes(ECOM_BOOKING_PATH)
}

/** 关闭已打开的电商订舱页签，保证始终只保留一个订舱页 */
async function closeExistingEcomBookingViews() {
  if (!store?.dispatch) return
  const visitedViews = store.state?.tagsView?.visitedViews || []
  const bookingViews = visitedViews.filter(isEcomBookingVisitedView)
  for (const view of bookingViews) {
    try {
      await store.dispatch('tagsView/delView', {
        path: view.path,
        query: view.query || {},
        fullPath: view.fullPath || view.path
      })
    } catch (e) {
      // ignore
    }
  }
}

export async function gotoEcomBooking(vm, payload = {}) {
  const router = vm?.$router
  if (!router) return false

  await closeExistingEcomBookingViews()

  const query = {}
  if (payload.md5Key) query.md5Key = payload.md5Key
  if (payload.containerType) query.containerType = payload.containerType
  if (payload.spuId) query.spuId = payload.spuId
  if (payload.bookingToken) query._bt = String(payload.bookingToken)
  // CMA 凭报价订舱：订舱页按下单记录里的报价快照展示，只能提交订舱
  if (payload.quotationRecordId) query.quotationRecordId = String(payload.quotationRecordId)

  if (hasMatchedRoute(router, { path: ECOM_BOOKING_PATH })) {
    await router.push({ path: ECOM_BOOKING_PATH, query })
    return true
  }

  if (hasMatchedRoute(router, { name: ECOM_BOOKING_ROUTE_NAME })) {
    await router.push({ name: ECOM_BOOKING_ROUTE_NAME, query })
    return true
  }

  const fallbackPath = getEcomBookingPath(vm)
  await router.push({ path: fallbackPath, query })
  return true
}
